export const translations = {
  ru: {
    nav: {
      links: [
        { id: "manifesto", label: "О нас" },
        { id: "directions", label: "Направления" },
        { id: "process", label: "Сделка" },
        { id: "compliance", label: "Комплаенс" },
      ],
      cta: "Запросить объём",
    },
    hero: {
      eyebrow: "Интродьюсеры сырьевых рынков",
      l1: "Прямой доступ к",
      l2: "институциональным",
      l3a: "объёмам ",
      l3gold: "золота",
      l4: "и нефтепродуктов",
      roleNote: "Мы не являемся продавцом золота или нефтепродуктов — мы посредники между компаниями. Наш заработок — комиссия от 1%, которая выплачивается ежемесячно в течение всего срока контракта.",
      sub: "Мы соединяем верифицированных покупателей с аффинажными заводами и держателями ресурсов. Физическое золото — от 500 кг в месяц. Светлые нефтепродукты — прямые аллокации НПЗ.",
      cta: "Запросить объём",
      process: "Как проходит сделка",
      imgAlt: "Физическое золото в слитках высшей пробы 999.9",
      verified: "Верифицировано",
      stats: [
        { value: "от 500 кг", label: "золота в месяц" },
        { value: "LBMA", label: "стандарт поставки" },
        { value: "Tier-1", label: "банковские каналы" },
      ],
    },
    marquee: [
      "Мы интродьюсеры, а не продавец",
      "Аффинажные заводы LBMA",
      "Физическое золото 999.9",
      "Тестовая партия 50 кг",
      "EN590 10PPM",
      "Авиакеросин JET A-1",
      "FOB · CIF Rotterdam",
      "Обеспечение SBLC",
    ],
    manifesto: {
      overline: "Наша роль",
      title: "Мы — интродьюсеры. Не продавец и не покупатель — связующее звено между вами и ресурсодержателем.",
      intro: "Мы находим покупателей для наших партнёров с крупными объёмами и открываем покупателям доступ к этим объёмам. Контракт всегда заключается напрямую между верифицированными сторонами.",
      chapters: [
        {
          num: "01",
          title: "Мы — посередине, а не в сделке",
          text: "Мы не продаём золото и не покупаем его. Мы связываем компании между собой: покупатель и ресурсодержатель встречаются напрямую, мы лишь открываем эту дверь.",
        },
        {
          num: "02",
          title: "Гарантия чистоты сделки",
          text: "Каждый контрагент проходит многоступенчатую проверку до того, как вы услышите его имя. Мы не работаем с серыми цепочками и «джокерами» рынка.",
        },
        {
          num: "03",
          title: "Безупречный комплаенс",
          text: "KYC, банковская верификация и NDA — обязательный протокол каждой сделки. Ваша репутация защищена процедурами, а не обещаниями.",
        },
      ],
    },
    directions: {
      overline: "Направления",
      title: "Золото — основа. Нефтепродукты — по запросу.",
      lead: "Только реальный товар, только верифицированные ресурсодержатели, только банковские процедуры.",
      coreBadge: "Основное направление",
      additionalBadge: "Дополнительное направление",
      cta: "Запросить условия",
      gold: {
        label: "Золотой деск",
        title: "Физическое золото 999.9",
        alt: "Слиток золота с клеймом аффинажного завода",
        specs: [
          "Проба 999.9 · стандарт LBMA Good Delivery",
          "Слитки 1 кг и 12.5 кг с клеймом аффинажного завода",
          "От 100 кг в месяц: тестовая партия 50 кг + 12 поставок за 12 месяцев",
          "Расчёты Bank-to-Bank или USDT, обеспечение SBLC",
        ],
      },
      petroleum: {
        label: "Нефтяной деск",
        title: "Светлые нефтепродукты",
        alt: "Морской танкер нефтепродуктов в терминале",
        note: "У партнёров — действующие аллокации НПЗ. Как интродьюсеры, мы организуем поставку под конкретный запрос покупателя.",
        specs: [
          "EN590 10PPM · дизельное топливо",
          "Jet A-1 · авиационный керосин",
          "Мазут M100 · D2 · сжиженный газ",
          "Поставка FOB / CIF Rotterdam, Fujairah",
        ],
      },
    },
    deal: {
      overline: "Сделка по золоту",
      title: "Как проходит сделка: поэтапно",
      sub: "Предварительная дорожная карта. Итоговые условия определяются SPA, KYC/AML-проверкой и согласованной банковской / аффинажной процедурой.",
      reqTitle: "Верификация покупателя",
      reqNote: "На раннем этапе наименование поставщика и корпоративные документы не распространяются через посредников. После квалификации организуется прямая встреча сторон.",
      requirements: [
        {
          title: "UAE Trade Licence",
          text: "Действующая лицензия ОАЭ с видом деятельности по торговле золотом / драгоценными металлами.",
        },
        {
          title: "Company KYC Pack",
          text: "Certificate of Incorporation, MOA / AOA, данные UBO и акционеров, паспорт уполномоченного подписанта.",
        },
        {
          title: "Proof of Funds",
          text: "Bank reference letter или иное подтверждение финансовой возможности завершить покупку.",
        },
      ],
      steps: [
        {
          num: "1",
          title: "Документы покупателя",
          text: "Покупатель направляет лицензию ОАЭ, KYC-пакет компании и подтверждение наличия средств (POF).",
        },
        {
          num: "2",
          title: "Квалификация и прямая встреча",
          text: "После предварительной проверки организуется прямое обсуждение условий между релевантными сторонами.",
        },
        {
          num: "3",
          title: "Единый SPA",
          text: "Один договор на тестовую партию 50 кг и 12 последующих поставок: цена, аффинаж, assay, инспекция, выдача, SBLC и реферальная модель.",
        },
        {
          num: "4",
          title: "Тестовая партия 50 кг",
          text: "Проверка реальности поставки и безопасная отработка процедуры оплаты / выдачи на металле, находящемся на аффинажном заводе.",
        },
        {
          num: "5",
          title: "12 партий / 12 месяцев",
          text: "Дальнейшие поставки по согласованному графику. Каждая партия оформляется schedule / commercial invoice в рамках того же SPA.",
        },
      ],
      trial: {
        title: "Процедура тестовой партии 50 кг",
        steps: [
          {
            title: "Золото на аффинаже",
            text: "Металл находится на refinery / аффинажном предприятии, а не передаётся «на руках».",
          },
          {
            title: "Assay и инспекция",
            text: "Проверяются вес, проба и иные согласованные параметры.",
          },
          {
            title: "Подтверждение параметров",
            text: "Стороны подтверждают результаты проверки в согласованном порядке.",
          },
          {
            title: "Оплата",
            text: "Bank-to-Bank Transfer или USDT по договорённости сторон.",
          },
          {
            title: "Выдача покупателю",
            text: "После подтверждения оплаты золото выпускается покупателю по процедуре refinery.",
          },
        ],
        note: "Ключевой принцип безопасности: золото не выдаётся до оплаты, а покупатель не работает «вслепую» вне согласованной процедуры аффинажа.",
      },
      cards: [
        {
          value: "до −3%",
          title: "Объёмная скидка",
          text: "По последующим партиям: 2% остаются покупателю, 1% — реферальное вознаграждение. Не относится к тестовой партии 50 кг.",
        },
        {
          value: "SBLC",
          title: "Банковское обеспечение",
          text: "Irrevocable Standby Letter of Credit от банка, приемлемого для обеих сторон. Это обеспечение платежа, а не escrow-счёт.",
        },
        {
          value: "0",
          title: "Слепых зон",
          text: "Золото не выдаётся до оплаты, а покупатель не работает вслепую вне согласованной процедуры аффинажа.",
        },
      ],
    },
    compliance: {
      overline: "KYC & Комплаенс",
      title: "Доверие, построенное на процедурах",
      items: [
        {
          title: "KYC / KYB верификация",
          text: "Полная проверка юридических лиц и бенефициаров по международным стандартам AML.",
        },
        {
          title: "Банковские каналы Tier-1",
          text: "Расчёты и верификация инструментов только через банки первого эшелона.",
        },
        {
          title: "NDA на каждую сделку",
          text: "Конфиденциальность сторон, объёмов и условий защищена договорно по умолчанию.",
        },
        {
          title: "Юридическая чистота",
          text: "Полный пакет документов: происхождение товара, экспортные лицензии, сертификаты.",
        },
      ],
    },
    contact: {
      overline: "Контакт",
      title: "Запросить объём",
      generalTitle: "Начать коммерческий диалог",
      text: "Оставьте параметры интереса — мы проверим текущую доступность у ресурсодержателей и вернёмся с конкретными условиями. Все запросы обрабатываются под NDA.",
      generalText: "Опишите коммерческий контекст, вашу компанию и тип интересующего контрагента. Мы свяжемся с вами, чтобы организовать первоначальный коммерческий диалог.",
      legal: "Отправляя запрос, вы соглашаетесь на обработку данных для ответа на коммерческое обращение. Мы не передаём информацию третьим лицам.",
      namePh: "Ваше имя *",
      companyPh: "Компания",
      emailPh: "Email *",
      messengerLabel: "Куда написать",
      whatsappPh: "50 123 4567 *",
      telegramPh: "Telegram @username *",
      volumePh: "Интересующий объём (напр. 500 кг / 50 000 барр.)",
      generalScopePh: "Коммерческий предмет или запрос (необязательно)",
      messagePh: "Сообщение",
      directionLabel: "Направление",
      directions: [
        { value: "b2b", label: "B2B" },
        { value: "gold", label: "Золото" },
        { value: "petroleum", label: "Нефть" },
        { value: "other", label: "Другое" },
      ],
      submit: "Отправить запрос",
      waTitle: "Связь в WhatsApp",
      waText: "Оставьте ваш номер — мы напишем первыми в течение рабочего дня.",
      waPhonePh: "50 123 4567",
      waSubmit: "Отправить",
      waSuccess: "Номер отправлен",
      waSuccessDesc: "Мы напишем вам в WhatsApp в ближайшее время.",
      successTitle: "Запрос отправлен",
      successDesc: "Мы свяжемся с вами в течение 24 часов по указанному каналу.",
      errorTitle: "Не удалось отправить запрос",
      errorDesc: "Попробуйте ещё раз или напишите нам напрямую.",
      whatsappOnly: "Для UAE-номеров префикс +971 добавляется автоматически; введите оставшиеся цифры номера WhatsApp.",
      otpTitle: "Подтвердите номер для отправки запроса",
      otpNotice: "Чтобы защитить форму от спама и не допустить, чтобы кто-то оставил ваш номер без вашего ведома, подтвердите, пожалуйста, номер кодом из WhatsApp. Если WhatsApp недоступен, мы один раз направим код по SMS на этот же номер.",
      otpConsent: "Я согласен(на) на обработку моих данных и связь со мной по данному коммерческому запросу, включая подтверждение моего номера через WhatsApp или SMS.",
      directConsent: "Я согласен(на) на обработку моих данных и связь со мной по данному коммерческому запросу.",
      draftSaving: "Сохраняем черновик заполненной формы в защищённом реестре…",
      draftSaved: "Черновик заполненной формы сохранён в защищённом реестре. Для отправки заявки дайте согласие и подтвердите номер.",
      draftSaveError: "Черновик пока не сохранён. Проверьте подключение и продолжите заполнение.",
      otpConsentRequired: "Подтвердите согласие на обработку данных и связь по заявке.",
      otpStatusLoading: "Проверяем доступный режим отправки…",
      otpStartSubmit: "Получить код в WhatsApp",
      otpCodeSent: "Код подтверждения отправлен",
      otpWhatsAppReady: "Подтвердите номер в WhatsApp",
      otpStartError: "Не удалось отправить код",
      otpStartErrorDesc: "Проверьте номер WhatsApp и повторите попытку немного позже.",
      otpVerifyTitle: "Введите код подтверждения",
      otpCodePrompt: "Введите одноразовый код, отправленный на номер",
      otpCodePh: "Код подтверждения",
      otpChangeNumber: "Изменить номер",
      otpVerifySubmit: "Подтвердить номер и отправить запрос",
      otpInboundTitle: "Подтвердите номер в WhatsApp",
      otpInboundPrompt: "Откройте WhatsApp и отправьте подготовленное сообщение. После подтверждения заявка будет отправлена автоматически.",
      otpContinueWhatsApp: "Продолжить в WhatsApp",
      otpCheckApproval: "Проверить подтверждение",
      otpCodeInvalid: "Введите код из 4–8 цифр.",
      otpVerifyError: "Не удалось подтвердить код",
      otpVerifyErrorDesc: "Проверьте код или запросите новый, изменив номер.",
      otpSmsFallback: "Код отправляется сначала в WhatsApp. Если в течение минуты код не введён, один раз будет отправлен SMS на этот же номер. Telegram и email не используются.",
      otpRetryCountdown: "Новый код можно запросить через",
      otpRequestNewCode: "Запросить новый код в WhatsApp",
      otpSupportEmail: "Если отправить запрос не получилось, напишите нам: info@melnikbrokers.ae",
    },
    footer: {
      tagline: "Организация коммерческих знакомств и первого контакта между компаниями. Отдельные направления по золоту, нефтепродуктам и расчётной координации. Дубай · ОАЭ.",
      clockLabel: "Дубай · GST",
      disclaimer: "MELNIK COMMERCIAL BROKERS действует как лицензированный коммерческий брокер: мы организуем коммерческое знакомство, но не продаём, не покупаем, не проверяем документы и не являемся стороной договоров между компаниями.",
    },
  },
  en: {
    nav: {
      links: [
        { id: "manifesto", label: "About" },
        { id: "directions", label: "Desks" },
        { id: "process", label: "Deal" },
        { id: "compliance", label: "Compliance" },
      ],
      cta: "Request volume",
    },
    hero: {
      eyebrow: "Commodity market introducers",
      l1: "Direct access to",
      l2: "institutional volumes",
      l3a: "of ",
      l3gold: "gold",
      l4: "and petroleum products",
      roleNote: "We are not a seller of gold or petroleum products — we are intermediaries between companies. Our earnings are a commission starting from 1%, paid monthly throughout the contract term.",
      sub: "We don't sell or buy gold ourselves — we connect verified buyers with refineries and resource holders. Physical gold — from 500 kg per month. Refined petroleum products — direct refinery allocations.",
      cta: "Request volume",
      process: "How a deal works",
      imgAlt: "Physical gold bars, 999.9 fine",
      verified: "Verified",
      stats: [
        { value: "from 500 kg", label: "gold per month" },
        { value: "LBMA", label: "delivery standard" },
        { value: "Tier-1", label: "banking channels" },
      ],
    },
    marquee: [
      "Introducers — not the seller",
      "LBMA refineries",
      "Physical gold 999.9",
      "50 kg trial tranche",
      "EN590 10PPM",
      "JET A-1 aviation kerosene",
      "FOB · CIF Rotterdam",
      "SBLC secured",
    ],
    manifesto: {
      overline: "Our role",
      title: "We are introducers. Neither seller nor buyer — the connecting link between you and the resource holder.",
      intro: "We find buyers for our partners' large volumes and open buyers' access to those volumes. The contract is always concluded directly between verified parties.",
      chapters: [
        {
          num: "01",
          title: "In between — not in the deal",
          text: "We do not sell gold and we do not buy it. We connect companies with each other: buyer and resource holder meet directly — we simply open that door.",
        },
        {
          num: "02",
          title: "Clean-deal guarantee",
          text: "Every counterparty passes multi-stage vetting before you ever hear their name. We do not work with grey chains or market jokers.",
        },
        {
          num: "03",
          title: "Impeccable compliance",
          text: "KYC, bank verification and NDA are the mandatory protocol of every deal. Your reputation is protected by procedures, not promises.",
        },
      ],
    },
    directions: {
      overline: "Desks",
      title: "Gold is the core. Petroleum on request.",
      lead: "Only real product, only verified resource holders, only banking procedures.",
      coreBadge: "Core focus",
      additionalBadge: "Additional desk",
      cta: "Request terms",
      gold: {
        label: "Gold desk",
        title: "Physical gold 999.9",
        alt: "Gold bar with refinery hallmark",
        specs: [
          "999.9 fineness · LBMA Good Delivery standard",
          "1 kg and 12.5 kg bars with refinery hallmark",
          "From 100 kg per month: 50 kg trial tranche + 12 shipments over 12 months",
          "Bank-to-bank or USDT settlement, SBLC security",
        ],
      },
      petroleum: {
        label: "Petroleum desk",
        title: "Refined petroleum products",
        alt: "Petroleum products tanker at a terminal",
        note: "Our partners hold live refinery allocations. As introducers, we arrange supply against a specific buyer request.",
        specs: [
          "EN590 10PPM · diesel",
          "Jet A-1 · aviation kerosene",
          "Fuel oil M100 · D2 · LPG",
          "FOB / CIF delivery: Rotterdam, Fujairah",
        ],
      },
    },
    deal: {
      overline: "Gold transaction",
      title: "How a deal works, step by step",
      sub: "Preliminary roadmap. Final terms are defined by the SPA, KYC/AML review and the agreed banking / refinery procedure.",
      reqTitle: "Buyer verification",
      reqNote: "Supplier name and corporate documents are not circulated through intermediaries at early stages. A direct meeting is arranged once the buyer is qualified.",
      requirements: [
        {
          title: "UAE Trade Licence",
          text: "A valid UAE licence with gold / precious metals trading activity.",
        },
        {
          title: "Company KYC Pack",
          text: "Certificate of Incorporation, MOA / AOA, UBO & shareholder data, authorised signatory passport.",
        },
        {
          title: "Proof of Funds",
          text: "Bank reference letter or other evidence of financial capacity to complete the purchase.",
        },
      ],
      steps: [
        {
          num: "1",
          title: "Buyer documents",
          text: "The buyer provides the UAE licence, company KYC pack and proof of funds (POF).",
        },
        {
          num: "2",
          title: "Qualification & direct meeting",
          text: "After preliminary screening, a direct discussion of terms is arranged between the relevant parties.",
        },
        {
          num: "3",
          title: "Single SPA",
          text: "One agreement covering the 50 kg trial tranche and 12 subsequent shipments: pricing, refinery, assay, inspection, release, SBLC and the referral model.",
        },
        {
          num: "4",
          title: "50 kg trial tranche",
          text: "Verification of supply reality and a safe rehearsal of the payment / release procedure on metal held at the refinery.",
        },
        {
          num: "5",
          title: "12 tranches / 12 months",
          text: "Further shipments on an agreed schedule. Each tranche is documented by a schedule / commercial invoice under the same SPA.",
        },
      ],
      trial: {
        title: "50 kg trial tranche procedure",
        steps: [
          {
            title: "Gold at the refinery",
            text: "The metal is held at the refinery — it is never passed around «in hands».",
          },
          {
            title: "Assay & inspection",
            text: "Weight, fineness and other agreed parameters are verified.",
          },
          {
            title: "Parameter confirmation",
            text: "The parties confirm the inspection results in the agreed manner.",
          },
          {
            title: "Payment",
            text: "Bank-to-bank transfer or USDT, as agreed by the parties.",
          },
          {
            title: "Release to the buyer",
            text: "Once payment is confirmed, the gold is released to the buyer under the refinery procedure.",
          },
        ],
        note: "The key safety principle: gold is not released before payment, and the buyer never operates blindly outside the agreed refinery procedure.",
      },
      cards: [
        {
          value: "up to −3%",
          title: "Volume discount",
          text: "On subsequent tranches: 2% stays with the buyer, 1% is a referral fee. Does not apply to the 50 kg trial tranche.",
        },
        {
          value: "SBLC",
          title: "Bank security",
          text: "Irrevocable Standby Letter of Credit from a bank acceptable to both parties. Payment security — not an escrow account.",
        },
        {
          value: "0",
          title: "Blind spots",
          text: "Gold is released only after payment, and the buyer never operates blindly outside the agreed refinery procedure.",
        },
      ],
    },
    compliance: {
      overline: "KYC & Compliance",
      title: "Trust built on procedures",
      items: [
        {
          title: "KYC / KYB verification",
          text: "Full screening of legal entities and beneficiaries to international AML standards.",
        },
        {
          title: "Tier-1 banking channels",
          text: "Settlement and instrument verification exclusively through first-tier banks.",
        },
        {
          title: "NDA on every deal",
          text: "Confidentiality of parties, volumes and terms is contractually protected by default.",
        },
        {
          title: "Legal integrity",
          text: "Complete documentation: product origin, export licences, certificates.",
        },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Request volume",
      generalTitle: "Start a commercial conversation",
      text: "Leave your parameters — we will check current availability with resource holders and come back with specific terms. All enquiries are handled under NDA.",
      generalText: "Share the commercial context, your company and the type of counterpart you are seeking. We will contact you to arrange the initial commercial dialogue.",
      legal: "By submitting a request you agree to data processing for a response to your commercial enquiry. We never share information with third parties.",
      namePh: "Your name *",
      companyPh: "Company",
      emailPh: "Email *",
      messengerLabel: "Where to message you",
      whatsappPh: "50 123 4567 *",
      telegramPh: "Telegram @username *",
      volumePh: "Volume of interest (e.g. 500 kg / 50,000 bbl)",
      generalScopePh: "Commercial scope or requirement (optional)",
      messagePh: "Message",
      directionLabel: "Direction",
      directions: [
        { value: "b2b", label: "B2B enquiry" },
        { value: "gold", label: "Gold" },
        { value: "petroleum", label: "Petroleum" },
        { value: "other", label: "Other enquiry" },
      ],
      submit: "Send request",
      waTitle: "WhatsApp contact",
      waText: "Leave your number — we will message you first within a business day.",
      waPhonePh: "50 123 4567",
      waSubmit: "Send",
      waSuccess: "Number sent",
      waSuccessDesc: "We will message you on WhatsApp shortly.",
      successTitle: "Request sent",
      successDesc: "We will contact you within 24 hours through the channel you selected.",
      errorTitle: "Failed to send the request",
      errorDesc: "Please try again or contact us directly.",
      whatsappOnly: "For UAE numbers, +971 is added automatically; enter the remaining WhatsApp number digits.",
      otpTitle: "Confirm your number to send the enquiry",
      otpNotice: "To protect the form from spam and prevent anyone from submitting your number without your knowledge, please confirm that this is your number with a WhatsApp code. If WhatsApp is unavailable, we may send one SMS code to the same number.",
      otpConsent: "I consent to the processing of my data and to being contacted about this commercial enquiry, including confirmation of my number through WhatsApp or SMS.",
      directConsent: "I consent to the processing of my data and to being contacted about this commercial enquiry.",
      draftSaving: "Saving the completed form draft to the secure register…",
      draftSaved: "The completed form draft is saved to the secure register. Give consent and confirm your number to send the enquiry.",
      draftSaveError: "The draft has not been saved yet. Check the connection and continue completing the form.",
      otpConsentRequired: "Please confirm consent to data processing and contact about this enquiry.",
      otpStatusLoading: "Checking the available submission mode…",
      otpStartSubmit: "Get code in WhatsApp",
      otpCodeSent: "Verification code sent",
      otpWhatsAppReady: "Verify your number in WhatsApp",
      otpStartError: "Unable to send the code",
      otpStartErrorDesc: "Check the WhatsApp number and try again shortly.",
      otpVerifyTitle: "Enter the verification code",
      otpCodePrompt: "Enter the one-time code sent to",
      otpCodePh: "Verification code",
      otpChangeNumber: "Change number",
      otpVerifySubmit: "Verify number and send request",
      otpInboundTitle: "Verify your number in WhatsApp",
      otpInboundPrompt: "Open WhatsApp and send the prepared message. The request will be submitted automatically after confirmation.",
      otpContinueWhatsApp: "Continue in WhatsApp",
      otpCheckApproval: "Check confirmation",
      otpCodeInvalid: "Enter a code of 4–8 digits.",
      otpVerifyError: "Unable to verify the code",
      otpVerifyErrorDesc: "Check the code or change the number to request a new one.",
      otpSmsFallback: "The code is sent to WhatsApp first. If no code is entered within one minute, one SMS will be sent to the same number. Telegram and email are not used.",
      otpRetryCountdown: "A new code can be requested in",
      otpRequestNewCode: "Request a new WhatsApp code",
      otpSupportEmail: "If you cannot send the request, contact us at info@melnikbrokers.ae",
    },
    footer: {
      tagline: "Organising commercial introductions and first contact between companies. Dedicated gold, petroleum and settlement-readiness directions. Dubai · UAE.",
      clockLabel: "Dubai · GST",
      disclaimer: "MELNIK COMMERCIAL BROKERS acts as a licensed commercial broker: we organise commercial introductions, but do not sell, buy, verify documents or act as a party to agreements between companies.",
    },
  },
};
